import ModalWrappedContent from '@/components/basicComponents/modal/modalWrappedContent';
import { themeVar } from '@/styles/theme';
import styled from 'styled-components';

interface IEditInvestorDeleteHouseholdDialogProps {
  isOpen: boolean;
  entityName: string;
  onConfirm: () => void;
  onClose: () => void;
}

const EditInvestorDeleteHouseholdDialog = ({ isOpen, entityName, onConfirm, onClose }: IEditInvestorDeleteHouseholdDialogProps) => {
  return (
    <ModalWrappedContent
      isOpen={isOpen}
      onClose={onClose}
      title="Delete Household"
      confirmButton={{
        name: 'Confirm',
        onClick: onConfirm,
        disabled: false
      }}
    >
      <ModalBody>
        <ModalDescription>
          <b>{entityName || ''}</b> is the only entity in this household. After this action this household will be deleted automatically.
        </ModalDescription>
        <ModalDescription>Please confirm that you want to proceed.</ModalDescription>
      </ModalBody>
    </ModalWrappedContent>
  );
};

export default EditInvestorDeleteHouseholdDialog;

const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;

const ModalDescription = styled.div`
  font-size: 19px;
  font-style: normal;
  text-align: center;
  line-height: 26.6px;
  color: ${themeVar('font.base')};
`;
